<template>
  <div>
    <ValidationObserver v-if="status === 'progress'" v-slot="{ invalid }">
      <div>
        <div class="row">
          <div class="col-md-6">
            <ValidationProvider
              tag="div"
              class="form-row mt-2"
              name="nombre"
              rules="required|only_text"
              v-slot="{ errors, classes }"
            >
              <label>Nombre</label>
              <input
                type="text"
                v-model="register.name"
                class="form-control"
                :class="{'is-valid': classes.valid, 'is-invalid': classes.invalid && classes.touched}"
                placeholder="Nombre"
              />
              <small
                v-if="errors[0]"
                autocomplete="off"
                :autofocus="true"
                class="form-text invalid-feedback"
              >{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
          <div class="col-md-6">
            <ValidationProvider
              tag="div"
              class="form-row mt-2"
              name="Apellido"
              rules="required|only_text"
              v-slot="{ errors, classes }"
            >
              <label>Apellido</label>
              <input
                type="text"
                v-model="register.lastname"
                class="form-control"
                :class="{'is-valid': classes.valid, 'is-invalid': classes.invalid}"
                placeholder="Apellido"
              />
              <small
                v-if="errors[0]"
                autocomplete="off"
                :autofocus="true"
                class="form-text invalid-feedback"
              >{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>

        <ValidationProvider
          tag="div"
          class="form-row mt-2"
          name="Correo"
          rules="email|required"
          v-slot="{ errors, classes }"
        >
          <label>Correo</label>
          <input
            type="email"
            class="form-control"
            :class="{'is-valid': classes.valid, 'is-invalid': classes.invalid}"
            v-model="register.email"
            placeholder="Correo"
          />
          <small
            v-if="errors[0]"
            autocomplete="off"
            :autofocus="true"
            class="form-text invalid-feedback"
          >{{ errors[0] }}</small>
        </ValidationProvider>
        <ValidationProvider
          tag="div"
          class="form-row mt-2"
          name="Teléfono"
          rules="number_phone"
          v-slot="{ errors, classes }"
        >
          <label>
            Teléfono
            <small class="text-muted" style="font-size: .7rem;">(opcional)</small>
          </label>
          <vue-tel-input
            class="form-control"
            autocomplete="off"
            defaultCountry="MX"
            :class="{'is-invalid': classes.invalid}"
            placeholder="Teléfono"
            @validate="getValuePhone"
            v-model="phone"
          ></vue-tel-input>

          <small
            v-if="errors[0]"
            autocomplete="off"
            :autofocus="true"
            class="form-text invalid-feedback"
          >{{ errors[0] }}</small>

          <br />
          <small
            v-if="phoneValidInternational"
            autocomplete="off"
            :autofocus="true"
            class="form-text invalid-feedback"
          >El número no coincide con el país</small>
        </ValidationProvider>
        <div class="form-row mt-1 d-flex flex-column justify-content-start">
          <small id="passwordHelpBlock" class="form-text text-muted">* campos requeridos</small>
          <small class="text-muted">
            Al registrarte, aceptas los
            <a
              href="/termimos-y-condiciones"
              target="_blank"
            >términos y condiciones</a>
          </small>
        </div>
        <div class="form-row mt-2">
          <vue-recaptcha
            ref="recaptcha"
            :sitekey="sitekey"
            @verify="onVerify"
            @expired="onExpired"
            :loadRecaptchaScript="true"
          ></vue-recaptcha>
        </div>
        <div class="form-row mt-2">
          <div class="d-flex align-items-center">
            <button
              class="btn btn-primary ml-auto mr-4"
              style="border-color: transparent;"
              :disabled="!captchaIsSolved || invalid || status==='sending'"
              @click="submit"
            >
              <span>{{ submitText }}</span>
            </button>
          </div>
        </div>
      </div>
    </ValidationObserver>

    

    <div
      v-if="status === 'warning' | status === 'success'"
      :class="`alert mb-5 fade show alert alert-${status}`"
      role="alert"
    >{{ msg }}</div>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
export default {
  components: { VueRecaptcha },
  props: {
    submitText: {
      type: String,
      default: "Envíar"
    },
    status: {
      type: String,
      default: "progress"
    },
    msg: {
      type: String,
      default: "Error!"
    }
  },
  data() {
    return {
      sitekey: process.env.VUE_APP_SITEKEY_CAPTCHA,
      captchaIsSolved: false,
      phoneValidInternational: true,
      isSending: true,
      phone: "",
      register: {
        email: "",
        name: "",
        lastname: "",
        phone: "",
        captcha: ""
      }
    };
  },
  methods: {
    submit() {
      if (this.register.phone === undefined || null) this.register.phone = "";
      this.$emit("submit", this.register);
    },
    onVerify(response) {
      this.captchaIsSolved = response && response.length > 10;
      this.register.captcha = response;
    },
    onExpired() {
      this.captchaIsSolved = false;
      this.register = {
        email: "",
        name: "",
        lastname: "",
        phone: "",
        eventid: "",
        captcha: ""
      };
    },
    getValuePhone(value) {
      this.phoneValidInternational = value.valid;
      this.register.phone = value.number.e164;
    }
  }
};
</script>